import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	MatterMortgageWithAssociations,
	TransactionType,
} from '@models/mortgage';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { ChangePriorityComponent } from '../../../manual/components/change-priority/change-priority.component';

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-general-details',
	templateUrl: './closer-sync-general-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncGeneralDetailsComponent {
	@Select(MatterMortgagesState.getSelectedMortgage)
	mortgage$: Observable<MatterMortgageWithAssociations>;
	public transactionType = TransactionType;

	constructor(private matDialog: MatDialog) {}

	editPriority(): void {
		this.matDialog.open(ChangePriorityComponent);
	}
}
